import api from "./api";

export function getHomePage() {
  return api.get(`/home`);
}
